<template>
	<b-card bg-variant="white" :header="$t('expenses.title')" style="height: 95%;margin-left: 7px">
		<div slot="header">
			<span>{{ $t('expenses.title') }}</span>
			<div class="card-header-actions">
				<b-link
					@click="newExpenses(null, 'create')"
					class="card-header-action btn-setting"
					style="font-size: 15px"
				>
					<i class="fa fa-plus-circle"></i>
				</b-link>


			</div>
		</div>
		<div class="certificate-list">
			<b-row>

				<div class="col-sm-2">
					<!--<label class="lebeltop">Типы расходов</label>-->
					<b-form-select v-model="filter.typeExpensesCode"
								   :plain="false"
								   :options="dropdowns.position.items"
								   size="sm"
								   label-for="typeExpensesName"
								   :required="true"
								   :text-field="'name'"
								   :value-field="'code'"
								   @reload="loadExpenses"
					>
						<template slot="first">
							<option :value="null">--
								{{$t('expenses.type')}}--
							</option>
						</template>
					</b-form-select>
				</div>
				<b-col sm="2" >
					<!--<label class="lebeltop">-->
					<!--<span class="redStar">-->

					<!--</span>Официальная дата</label>-->
					<b-form-group
						label-size="sm"
						label-for="refName"
						class="required"
					>

						<date-picker v-model="filter.formalDate"
									 lang="ru"
									 size="sm"
									 placeholder="dd-mm-yyyy"
									 valueType="format"
									 format="DD-MM-YYYY"
						></date-picker>
					</b-form-group>
				</b-col>
				<b-col sm="2" style="
    margin-left: 30px;
">
					<!--<label class="lebeltop">-->
					<!--<span class="redStar">-->

					<!--</span>Месяц</label>-->
					<b-form-group
						label-size="sm"
						label-for="refName"
						class="required"
					>

						<date-picker v-model="filter.forWhatDate"
									 lang="ru"
									 type="month"
									 placeholder="yyyy-mm"
									 valueType="format"
									 format="MM-YYYY"
						></date-picker>
					</b-form-group>
				</b-col>
				<b-col sm="2" style="margin-left: 40px;">
					<!--<label for="input-small">-->
					<!--&lt;!&ndash;<span>&ndash;&gt;-->
					<!--&lt;!&ndash;Сумма&ndash;&gt;-->
					<!--&lt;!&ndash;</span>&ndash;&gt;-->
					<!--</label>-->
					<b-input-group
						size="sm"
						class="mb-3"
					>
						<b-form-input
							:placeholder="$t('pos.sum')"
							v-model="filter.price"
							type="text"
						>
						</b-form-input>
					</b-input-group>
				</b-col>
				<b-col sm="2" >
					<label for="input-small">
						<!--<span>-->
						<!--Search-->
						<!--</span>-->
						<b-input-group
							size="sm"
							class="mb-3"
						>
							<b-button @click="searchFilterClick" block variant="info"><span
								style="color: white"><i data-v-43fbd8ea="" class="fa fa-search"></i>
								{{$t('incomeFilter.search')}}</span></b-button>
						</b-input-group>
					</label>
				</b-col>
				<b-col sm="2" style="margin-left: -70px;">
					<label for="input-small">
						<!--<span>-->
						<!--Search-->
						<!--</span>-->
						<b-input-group
							size="sm"
							class="mb-3"
						>
							<b-button @click="clearSearch" block variant="danger"><span style="color: white"><i
								data-v-43fbd8ea="" class="fa fa-close"></i> {{$t('incomeFilter.clear')}}</span>
							</b-button>
						</b-input-group>
					</label>
				</b-col>
			</b-row>
		</div>
		<b-table class="generalTableClass" hover="hover" striped="striped"
				 :items="expensesList" :fields="computedFields">

			<template slot="price" slot-scope="data">
				<span>{{ data.item.price | currency({symbol:userDepCurrencyName, fractionCount: 2, symbolPosition: 'back'}) }}</span>
			</template>

			<template slot="actions" slot-scope="data">


				<b-link :key="data.item.id + 'delete'"
						@click="onOpen(data.item.id)"
						:id="'popOverDelete'+data.item.id"
						v-if="$can('delete', 'employee')">
					<i class="fa fa-trash"></i>
				</b-link>

				<b-link @click="updateExpensestOpenModal(data.item.id)" v-b-tooltip.hover
				>
					<i class="fa fa-edit"></i>
				</b-link>

				<b-popover
					:key="data.item.id + 'popover'"
					:target="'popOverDelete'+data.item.id"
					placement="auto"
					container="myContainer"
					:ref="'popover'+data.item.id"
					class="refDeleteConfirm"
				>
					<template slot="title">
						<b-button @click="onClose(data.item.id)" class="close"
								  aria-label="Close"
								  style="margin-left: 5px">
							<span class="d-inline-block" aria-hidden="true">&times;</span>
						</b-button>
						{{$t('want_to_delete?')}}
					</template>
					<div>

						<div class="row mt-1">
							<div class="col-6">
								<b-button variant="outline-danger" size="sm" block
										  @click="onClose(data.item.id)">{{$t('actions.no')}}
								</b-button>
							</div>
							<div class="col-6">
								<b-button variant="outline-success" size="sm" block
										  @click="onOk(data.item.id)">{{$t('actions.yes')}}
								</b-button>
							</div>
						</div>
					</div>
				</b-popover>


			</template>
		</b-table>
		<nav>
			<b-pagination :total-rows="totalExpenses" :per-page="search.limit" v-model="search.page"
						  :prev-text="$t('pagination.prev')"
						  :next-text="$t('pagination.next')" hide-goto-end-buttons/>
		</nav>
		<vs-sidebar :click-not-close="true" position-right parent="body" default-index="1" color="primary"
					class="create-modal" spacer
					v-model="sidebarOpen">
			<b-container index="1" v-if="sidebarOpen">
				<add-expenses
					:mode="mode"
					@not-close="closable = $event"
					@close="closeSidebarExpenses()"

				></add-expenses>
			</b-container>
		</vs-sidebar>
	</b-card>

</template>

<script>
	import AddExpenses from "./addExpenses";
	import {mapActions, mapState} from "vuex";
	import ReferencesService from "../../../services/references.sevice";

	export default {
		name: "List",
		components: {AddExpenses},
		data() {
			return {
				filter: {
					typeExpensesCode: null,
					formalDate: null,
					forWhatDate: null,
					price: null
				},
				dropdowns: {
					position: {
						items: [],
						value: null,
					}
				},
				mode: 'create',
				sidebarOpen: false,
				itemList: [],
				search: {
					page: 1,
					limit: 20,

				},
				currentPage: 1,
				perPage: 20,
			}
		},
		methods: {
			clearSearch() {
				let data = {}
				this.filter.formalDate = null;
				this.filter.forWhatDate = null;
				this.filter.price = null;
				this.filter.typeExpensesCode = null;
				data.search = this.search;
				data.filter = this.filter;
				this.searchFilter(data);
			},
			searchFilterClick() {
				if (this.filter.forWhatDate == "") {
					this.filter.forWhatDate = null;
				}
				if (this.filter.formalDate == "") {
					this.filter.formalDate = null;
				}
				let data = {}
				data.search = this.search;
				data.filter = this.filter;
				this.searchFilter(data);
			},
			...mapActions('expenses', [
				'getAllExpensesStore', 'deleteExpensesStore', 'getExpensesById', 'searchFilter'
			]),
			loadExpenses() {
				ReferencesService.getReferenceChildren(`expenses`).then(response => {
					this.dropdowns.position.items = response.data;

				})
			},
			onOpen(itemId) {
				let refName = 'popover' + itemId;
				this.$refs[refName].$emit('open')
			},
			onClose(itemId) {
				let refName = 'popover' + itemId;
				this.$refs[refName].$emit('close')
			},
			async onOk(itemId) {
				this.onClose(itemId)
				await this.expensesDelete(itemId);
			},
			async expensesDelete(id) {
				await this.deleteExpensesStore(id);
				await this.getAllList();

			},
			newExpenses(empty, mode) {
				this.sidebarOpen = true;
				this.mode = mode;
			},
			closeSidebarExpenses($event) {
				this.sidebarOpen = false;
			},
			getAllList() {
				let data = {}
				data.search = this.search;
				data.filter = this.filter;
				this.searchFilter(data);
			},
			async updateExpensestOpenModal(id) {
				await this.getExpensesById(id);
				this.mode = "edit";
				this.sidebarOpen = true;
			}


		},
		created() {
			this.loadExpenses();
			this.getAllList();
		},
		computed: {
			...mapState('expenses', [
				'expensesList', 'totalExpenses'
			]),
			...mapState(['userDepCurrencyName']),
			computedFields() {
				return [
					{
						key: 'id',
						label: "Id",
						'class': 'role_id',
					},

					{
						key: 'formalDate',
						label: this.$t('expenses.date')

					},
					{
						key: 'forWhatDate',
						label: this.$t('expenses.month')

					},
					{
						key: 'typeExpensesName',
						label: this.$t('expenses.type'),
						'class': 'min-120',
					},
					{
						key: 'price',
						label: this.$t('pos.sum')

					},

					{
						key: 'reason',
						label: this.$t('incomes.reason')

					},
					{
						key: 'actions',
						label: this.$t('actions.title'),
						'class': 'table_actions'

					},


				]
			},
		},
		watch: {
			'search.page': {
				handler(newValue) {
					if (newValue) {
						let data = {}
						data.search = this.search;
						data.filter = this.filter;
						this.searchFilter(data);
					}
				}
			}
		}
	}
</script>

<style scoped>

</style>
